import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ProcessService } from '../proxy/controlling/controllers/process.service';
import { ActivityGroupService } from '../proxy/controlling/controllers/activity-group.service';
import { InternalOrderService } from '../proxy/controlling/controllers/internal-order.service';
import { CurrencyService } from '../proxy/controlling/controllers/currency.service';
import { ActivityService } from '../proxy/controlling/controllers/activity.service';
import { PaymentTypeService } from '@controlling/proxy/controlling/controllers/payment-type.service';
import { UnitOfMeasureService } from '@general/proxy/general/controllers/unit-of-measure.service';
import { SilvicultureActivityParameter } from '@controlling/silviculture-activity-parameter/silviculture-activity-parameter';
import { RoadActivityParameter } from '@controlling/road-activity-parameter/road-activity-parameter';
import { HarvestActivityParameter } from '@controlling/harvest-activity-parameter/harvest-activity-parameter';
import { LogisticsActivityParameter } from '@controlling/logistics-activity-parameter/logistics-activity-parameter';
import { NurseryActivityParameter } from '@controlling/nursery-activity-parameter/nursery-activity-parameter';
import { PatrimonyActivityParameter } from '@controlling/patrimony-activity-parameter/patrimony-activity-parameter';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYPROCESSPARAMETRIZATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('useLevel', 'Entity.ActivityProcessParametrization.UseLevel')
    .build(),
  FieldBuilder
    .checkbox('isLiquidable', 'Entity.ActivityProcessParametrization.IsLiquidable')
    .build(),
  FieldBuilder
    .checkbox('isDirect', 'Entity.ActivityProcessParametrization.IsDirect')
    .build(),
  FieldBuilder
    .foreignKey('processId', 'Entity.Process', ProcessService)
    .displayFromNested('process.name')
    .sortBy('process.name')
    .build(),
  FieldBuilder
    .foreignKey('activityGroupId', 'Entity.ActivityGroup', ActivityGroupService)
    .displayFromNested('activityGroup.name')
    .sortBy('activityGroup.name')
    .build(),
  FieldBuilder
    .foreignKey('internalOrderId', 'Entity.InternalOrder', InternalOrderService)
    .displayFromNested('internalOrder.name')
    .sortBy('internalOrder.name')
    .build(),
  FieldBuilder
    .foreignKey('currencyId', 'Entity.Currency', CurrencyService)
    .required()
    .displayFromNested('currency.name')
    .sortBy('currency.name')
    .build(),
  FieldBuilder
    .foreignKey('activityId', 'Entity.Activity', ActivityService)
    .required()
    .displayFromNested('activity.name')
    .sortBy('activity.name')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('paymentTypeId', 'Entity.PaymentType', PaymentTypeService)
    .required()
    .displayFromNested('paymentType.name')
    .sortBy('paymentType.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('unitOfMeasureId', 'Entity.UnitOfMeasure', UnitOfMeasureService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const ACTIVITYPROCESSPARAMETRIZATION_CONFIG = {
  entityName: 'ActivityProcessParametrization',
  localizationKey: 'Controlling::Entity.ActivityProcessParametrization',
  fields: ACTIVITYPROCESSPARAMETRIZATION_FIELDS,
  permission: 'ControllingActivities.ActivityProcessParametrizations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
  getChildren: (row: any, allChildren: any[]) => {
    const process = row?.process;
    if (!process) {
      return [];
    }
    const processName = process.entityName || process.name;
    if (!processName) {
      return [];
    }
    const lowerTypeName = processName.toLowerCase();
    return allChildren.filter(child => child.entityName.toLowerCase() === lowerTypeName);
  },
  children: [
    {
      entityName: 'SilvicultureActivityParameter',
      foreignKeyField: 'activityProcessParametrizationId',
      localizationKey: 'Controlling::Entity.SilvicultureActivityParameter',
      component: SilvicultureActivityParameter,
    },
    {
      entityName: 'RoadActivityParameter',
      foreignKeyField: 'activityProcessParametrizationId',
      localizationKey: 'Controlling::Entity.RoadActivityParameter',
      component: RoadActivityParameter,
    },
    {
      entityName: 'HarvestActivityParameter',
      foreignKeyField: 'activityProcessParametrizationId',
      localizationKey: 'Controlling::Entity.HarvestActivityParameter',
      component: HarvestActivityParameter,
    },
    {
      entityName: 'NurseryActivityParameter',
      foreignKeyField: 'activityProcessParametrizationId',
      localizationKey: 'Controlling::Entity.NurseryActivityParameter',
      component: NurseryActivityParameter,
    },
    {
      entityName: 'LogisticsActivityParameter',
      foreignKeyField: 'activityProcessParametrizationId',
      localizationKey: 'Controlling::Entity.LogisticsActivityParameter',
      component: LogisticsActivityParameter,
    },
    {
      entityName: 'PatrimonyActivityParameter',
      foreignKeyField: 'activityProcessParametrizationId',
      localizationKey: 'Controlling::Entity.PatrimonyActivityParameter',
      component: PatrimonyActivityParameter,
    },
  ]
};
